import { Map } from 'immutable';
import defaultDialogReducer from '../../defaultDialogReducer';
import {dialogsNames} from '../../../enums/dialogsNames';
import { actionTypes as actionTypes } from '../../../actions/Dialogs/UpdateKitTypeVersionDialog/updateKitTypeVersionDialogActions.js';

let defaultState = {
  loading: false,
  show: false,
  items: null,
  kitTypeId: null,
};

export default function(state = Map(defaultState), action) {
  switch (action.type) {
    case actionTypes.UPDATE_KIT_TYPE_VERSION_DIALOG_SHOW:
      return state.set('items', action.payload?.workOrders)
                  .set('kitTypeId', action.payload?.kitTypeId)
                  .set('headerData', action.payload?.headerData)
                  .set('show',true);

    default:
      return defaultDialogReducer(state, action, dialogsNames.UPDATE_KIT_TYPE_VERSION_DIALOG, defaultState);
  }

}
